<h1 mat-dialog-title>Team Member Details</h1>
<div mat-dialog-content>
  <form [formGroup]="teamMemberDetailsForm">
    <div>
      <mat-form-field class="input">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="input">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email">
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="input">
        <mat-label>Phone Number</mat-label>
        <input matInput formControlName="phoneNumber" (keyup.enter)="saveTeamMember()">
        @if (teamMemberDetailsForm.get('phoneNumber')!.hasError('required')) {
          <mat-error>Phone Number is required.</mat-error>
        }
        @if (teamMemberDetailsForm.get('phoneNumber')!.hasError('maxlength') || teamMemberDetailsForm.get('phoneNumber')!.hasError('minlength')) {
          <mat-error>
            Phone Number must be 10 characters.
          </mat-error>
        }
      </mat-form-field>
    </div>
    <br/>
    <div>
      Alert Notification Preferences
    </div>
    <div>
      <mat-checkbox formControlName="voiceNotifications">Voice</mat-checkbox>
      <mat-checkbox formControlName="smsNotifications">SMS</mat-checkbox>
      <mat-checkbox formControlName="emailNotifications">Email</mat-checkbox>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close(false)">Cancel</button>
  <button mat-button [mat-dialog-close]="teamMemberDetailsForm.value" (click)="saveTeamMember()"
  [disabled]="!teamMemberDetailsForm.valid || !atLeastOneContactMethodEnabled()">Save</button>
</div>